import Container from '../Container'
import LexicalContent from '@/components/LexicalContent'
export interface IProps {
  richTextField?: {
    root: {
      type: string
      children: {
        type: string
        version: number
        [k: string]: unknown
      }[]
      direction: ('ltr' | 'rtl') | null
      format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
      indent: number
      version: number
    }
    [k: string]: unknown
  } | null
  anochrLink?: string
  textOnly?: boolean
  inline?: boolean
  timeStamps?: {
    value: string 
    mediaId: string
  }[]
}

export const RenderRichTexComponent = ({ richTextField, anochrLink, textOnly, inline, timeStamps }: IProps) => {
  return (
    <div className={`first:mt-0 richTextContent ${inline ? 'inline' : ''}`} id={anochrLink}>
      <Container className={`${inline ? 'inline' : ''}`}>
        <div className={`prose dark:prose-invert md:prose-lg ${inline ? 'inline' : ''}`}>
          {/* @ts-expect-error  from lexical*/}
          <LexicalContent childrenNodes={richTextField?.root?.children} lazyLoadImages={false} textOnly={textOnly} inline={inline} timeStamps={timeStamps}/>
        </div>
      </Container>
    </div>
  )
}

export default RenderRichTexComponent
